import { OrganizationsManager } from '../common/OrganizationsManager'

/**
 * load userOrgGroupsFeature
 *
 * ユーザーの組織グループを読み込む (on init app)
 */
export const useUserOrgGroupsFeature = () => {
  $core.$utils.registerFunctionLoggedInExecuteOnce({
    appHookFunctionRegisterKey: 'loadUserOrgsManager',
    onceLoadFunction: async () => {
      try {
        await loadOrgs()
      } catch (e) {
        console.error(e)
      }
    },
    hookPriority: 5000,
  })
  // TODO: 組織の編集時に refresh する
  const reloadTargetModelNames = [
    'organizations',
    'junctionUsersAndGroups',
    'junctionUsersAndOrgsAndPositions',
  ]
  reloadTargetModelNames.forEach((modelName) => {
    $core.$appHook.on(`${modelName}.afterSave`, ({ index }) => {
      // 一括保存時に 初回だけ loadOrgs を呼ぶ
      if (index === 0) {
        setTimeout(() => {
          loadOrgs()
        }, 10)
      }
    })
  })
}

const loadOrgs = async () => {
  const orgs = await $core.$models.organizations.find({
    limit: -1,
    fields: ['*', 'users.*'],
  })
  await $core.$organizationsManager.loadOrganizations(orgs)
}
